export const FLAG_IS_IDP_REDIRECT = 'IdpRedirect';
export const getTenantIdFromEnvironment = (environment) => {
    switch (environment) {
        case 'DEV':
            return 'af04b4e1-0667-4132-8cfb-33c6bd55d835';
        case 'QA':
            return 'fc0804bf-dafc-4963-a148-1301a8413c55';
        case 'PROD':
            return '25cfaefd-12bc-4ce5-b8d9-17c5beece498';
        default:
            return '25cfaefd-12bc-4ce5-b8d9-17c5beece498';
    }
};
export const getLoginOriginFromEnvironment = (environment) => {
    switch (environment) {
        case 'DEV':
            return 'https://login.sew-d.com';
        case 'QA':
            return 'https://login.sew-qa.com';
        case 'PROD':
            return 'https://login.sew-eurodrive.com';
        default:
            return 'https://login.sew-eurodrive.com';
    }
};
export const isSewLocation = () => {
    const isEdge = /Edg/.test(navigator.userAgent);
    return isEdge && document.cookie.split(';').some(cookie => cookie.trim().startsWith('sew_location='));
};
export const isB2CSessionActive = () => {
    return document.cookie.split(';').some(cookie => cookie.trim() === 'B2CSessionActive=X');
};
export const setSessionCookie = (name, value) => {
    document.cookie = `${name}=${value}; path=/; SameSite=None; Secure;`;
};
export const deleteCookie = (name) => {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure;`;
};
//# sourceMappingURL=msal-helper.js.map